import React, { useEffect, useState, useCallback } from 'react'
import { Container, Spinner } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { requestGetPasoActual } from '../utils/requests'
import { MapStepToRoute } from '../utils/steps'

function Home() {
  const [isLoading, setIsLoading] = useState(true)
  const history = useHistory()

  const switchPage = useCallback(
    (paso) => {
      const page = MapStepToRoute(paso) ?? '/ddjj/terminos'
      history.push(page)
    },
    [history]
  )

  const redireccionar = useCallback(() => {
    setIsLoading(true)
    requestGetPasoActual()
      .then(({ status, content }) => {
        if (status === 200) switchPage(content?.paso)
      })
      .finally(() => setIsLoading(false))
  }, [switchPage])

  useEffect(() => {
    redireccionar()
  }, [redireccionar])

  return (
    <>
      {isLoading && (
        <Container className="padding-top-4x padding-bottom-4x">
          <center>
            <Spinner animation="border" variant={'primary'} />
          </center>
        </Container>
      )}
    </>
  )
}

export default Home
